<template>
  <div class="container">
    <div class="module_title">
      <span>审核管理 》提现申请</span>

    </div>
    <div class="content">
      <div class="queryBox">
        <el-form ref="ruleForm" style="display: flex;flex-wrap: wrap;">
          <el-form-item label="审核状态：" style="width: 250px;">
            <el-select v-model="postForm.primary_status" placeholder="请选择" clearable>
              <el-option v-for="item in options2" :key="item.dictionary_key" :label="item.dictionary_value"
                         :value="item.dictionary_key">
              </el-option>

            </el-select>
          </el-form-item>
          <el-form-item label="提现状态：" style="width: 250px;">
            <el-select v-model="postForm.final_status" placeholder="请选择" clearable>
              <el-option v-for="item in options1" :key="item.dictionary_key" :label="item.dictionary_value"
                         :value="item.dictionary_key">
              </el-option>

            </el-select>
          </el-form-item>
          <!--          <el-form-item label="企业名称：" prop="" style="width: 300px;">-->
          <!--            <el-input v-model="postForm.enterprise_name" placeholder="请输入企业名称"></el-input>-->
          <!--          </el-form-item>-->
          <el-form-item label="提交申请时间：" prop="date">
            <el-date-picker unlink-panels v-model="formatObj.date1" type="datetimerange" range-separator="-"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" icon="el-icon-search" @click="search"
                       class="margin_left_20">查询
            </el-button>
          </el-form-item>


        </el-form>
      </div>
      <div class="data_list">
        <el-table :data="tableData" row-key="code" border lazy :stripe="true" :highlight-current-row="true"
                  :header-cell-style="{ background: '#eee', color: '#606266' }" v-loading="loading"
                  element-loading-background="#fff" element-loading-text="数据正在加载中"
                  element-loading-spinner="el-icon-loading" ref="refTable" :height="'100%'">

          <el-table-column prop="real_name" label="账号名称" :show-overflow-tooltip="true" width="120"/>
          <el-table-column prop="phone" label="手机号" :show-overflow-tooltip="true" width="100"/>
          <el-table-column prop="bank_name" label="企业开户行名称" :show-overflow-tooltip="true" min-width="120"/>
          <el-table-column prop="apply_amount_str" label="申请提现金额" :show-overflow-tooltip="true" width="150">
            <template v-slot="{ row }">
              <span>{{row.apply_amount*0.01}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="available_amount_str" label="账户可提现总金额" :show-overflow-tooltip="true" width="150">
            <template v-slot="{ row }">
              <span>{{row.available_amount*0.01}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ctm" label="申请时间" width="140" :show-overflow-tooltip="true"/>

          <el-table-column prop="primary_status" label="审核状态" width="80" :show-overflow-tooltip="true">
            <template v-slot="{ row }">
              <div v-for="item in options2" :key="item.dictionary_key">
                          <span v-if="item.dictionary_key == row.primary_status.toString()">
                                    <el-tag>{{ item.dictionary_value }}</el-tag>
                                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="auditor_time" label="审核时间" width="140" :show-overflow-tooltip="true">
            <template v-slot="{ row }">
              <span v-if="row.primary_status == 1">无</span>
              <span v-else>{{$tools.parserDateTime('datetime',row.auditor_time)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="final_status" label="提现状态" width="80" :show-overflow-tooltip="true">
            <template v-slot="{ row }">
              <div v-for="item in options1" :key="item.dictionary_key">
                          <span v-if="item.dictionary_key == row.final_status.toString()">
                                    <el-tag>{{ item.dictionary_value }}</el-tag>
                                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="transfer_name" label="转账人" width="120" :show-overflow-tooltip="true"/>
          <el-table-column prop="transfer_time" label="转账时间" width="140" :show-overflow-tooltip="true"/>
          <el-table-column width="150" fixed="right" label="操作">
            <template slot-scope="{row}">
              <el-button @click="detail(row)" type="text" size="small" class="">查看</el-button>
              <el-button v-if="row.primary_status == 1" @click="examine(row)" type="text" size="small" class="">审核
              </el-button>
              <el-button v-if="row.final_status == 1" @click="transfer(row)" type="text" size="small" class="">转账
              </el-button>
              <!--              <el-button @click="del(row)" type="text" size="small" class="btn_text_red">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination class="pagination" background @size-change="handleSizeChange"
                     @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30]"
                     :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

    </div>
    <dialogForm1 ref="dialogForm1" @ok="getList()"></dialogForm1>

  </div>
</template>

<script>
import dialogForm1 from './components/dialogForm1.vue'

export default {
  components: {
    dialogForm1,
  },
  data() {
    return {
      options1: [],//提现状态
      options2: [],//审核状态


      // 搜索区域
      formatObj: {
        date1: [],
      },
      // 分页
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false,

      tableData: [],
      postForm: {
        page: 1,
        limit: 10,
        primary_status: '1',
        final_status: '',
        // enterprise_name: '',
        "ctime_start": "",
        "ctime_end": "",
      },
    }
  },
  mounted() {
    this.getDictsData('TM-TC-TXZT', 'options1')
    this.getDictsData('TM-TC-SHZT', 'options2')

    this.getList()
  },
  methods: {
    back() {
      this.$router.go(-1)
    },

    // 获取数据字典值
    async getDictsData(dict, optionsNmae) {
      let options = [];
      await this.$tools
          .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
            data: {
              dictionary_code: dict,
            },
          })
          .then((res) => {
            if (res.data.code == 0) {
              options = res.data.data.dictionary_detail;
            } else {
              // this.$message({ type: "error", message: res.data.msg });
            }
          })
          .catch((err) => {
            // this.$message({ type: "error", message: err });
          });
      this[optionsNmae] = options;
    },

    getList() {
      this.loading = true;
      this.$tools
          .asyncPost(
              this,
              this.$baseUrl.withdrawalList, {
                data: {
                  page: this.currentPage,
                  limit: this.pagesize,
                  start_time: this.formatObj.date1 ? this.formatObj.date1[0] : "",
                  end_time: this.formatObj.date1 ? this.formatObj.date1[1] : "",
                  primary_status: this.postForm.primary_status == '' ? 0 : parseInt(this.postForm.primary_status),
                  final_status: this.postForm.final_status == '' ? 0 : parseInt(this.postForm.final_status)
                }
              }).then((res) => {
        if (res.data.code == 0) {
          this.tableData = res.data.data.data
          this.total = res.data.data.total
        } else {
          this.$message({type: "error", message: res.data.msg});
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
      });
    },
    handleSizeChange: function (size) {
      this.pagesize = size; //每页下拉显示数据
      this.getList();
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage; //点击第几页
      this.getList();
    },
    search() {
      this.currentPage = 1
      this.getList()
    },
    // 重置
    reset() {
      let obj = {
        "position_type_id": "",//类型
        "position_bidding_state": "",//竞价状态
        "position_bidding_start": "",//竞价开始时间
        "position_bidding_end": "",//竞价结束时间
      }
      Object.keys(obj).forEach((key) => {
        this.postForm[key] = obj[key];
      });
      this.formatObj.date1 = []
      this.formatObj.position_type_id = []

      this.currentPage = 1;
      this.getList()
    },
    //查看
    detail(row) {
      this.$refs.dialogForm1.dialogVisible = true
      this.$refs.dialogForm1.init(row, '查看')
    },
    //审核
    examine(row) {
      this.$refs.dialogForm1.dialogVisible = true
      this.$refs.dialogForm1.init(row, '提现审核')
    },
    //转账
    transfer(row) {
      this.$refs.dialogForm1.dialogVisible = true
      this.$refs.dialogForm1.init(row, '转账')
    },
    //删除
    del(row) {
      this.$MessageBox.confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return
        this.$tools
            .asyncPost(
                this,
                this.$baseUrl.trainingCourseVideoDel, {
                  data: {
                    ids: [row.id],
                  }
                }).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          } else {
            this.$message({type: "error", message: res.data.msg});
          }

        }).catch((err) => {
        });
      })
    }
  }
}
</script>

<style scoped lang="less" src="./index.less"></style>